var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 21.875H15.625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48828 10.1562C5.48697 9.23004 5.66893 8.31275 6.02365 7.45718C6.37838 6.6016 6.89887 5.82467 7.55515 5.17111C8.21142 4.51756 8.99052 4.0003 9.84756 3.64914C10.7046 3.29797 11.6226 3.11983 12.5488 3.12499C16.416 3.15428 19.5117 6.36717 19.5117 10.2441V10.9375C19.5117 14.4336 20.2441 16.4648 20.8887 17.5781C20.9571 17.6967 20.9932 17.8311 20.9933 17.968C20.9935 18.105 20.9576 18.2395 20.8894 18.3582C20.8211 18.4769 20.7229 18.5755 20.6045 18.6443C20.4861 18.7131 20.3517 18.7495 20.2148 18.75H4.78515C4.64825 18.7495 4.51387 18.7131 4.39549 18.6443C4.27711 18.5755 4.17888 18.4769 4.11063 18.3582C4.04239 18.2395 4.00653 18.105 4.00665 17.968C4.00677 17.8311 4.04287 17.6967 4.11132 17.5781C4.75585 16.4648 5.48828 14.4336 5.48828 10.9375V10.1562Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.2ae93ca7.svg";
export { ForwardRef as ReactComponent };